package com.eladfinish.bible.contest.screens.search.ui

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.left_arrow
import com.eladfinish.bible.contest.right_arrow
import com.eladfinish.bible.contest.screens.search.model.HorizontalDirection
import com.eladfinish.bible.contest.search_ai
import com.eladfinish.bible.contest.search_expression
import com.eladfinish.bible.contest.ui.components.RightToLeftContainer
import com.eladfinish.bible.contest.ui.components.buttons.AutoResizeItemButtonTextWithLongClick
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonTextWithLongClick
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun SearchButtonContent(
    isButtonSearchEnabled: Boolean,
    shouldShowAiSearch: Boolean,
    onSearchClick: () -> Unit,
    onSearchLongClick: () -> Unit,
    onAiSearchClick: () -> Unit,
    onHorizontalArrowClick: (HorizontalDirection) -> Unit,
    onHorizontalArrowLongClick: (HorizontalDirection) -> Unit,
) {
    val fontSize = 18.sp
    Row(modifier = Modifier.fillMaxWidth()) {
        ItemButtonTextWithLongClick(
            modifier = Modifier
                .weight(1.5f)
                .padding(1.dp),
            text = stringResource(resource = SharedRes.strings.right_arrow),
            fontSize = fontSize,
            borderWidth = 0,
            onClick = {
                onHorizontalArrowClick(HorizontalDirection.RIGHT)
            },
            onLongClick = {
                onHorizontalArrowLongClick(HorizontalDirection.RIGHT)
            },
        )

        val weight = 6f

        AutoResizeItemButtonTextWithLongClick(
            modifier = Modifier
                .weight(weight)
                .padding(1.dp),
            text = stringResource(resource = SharedRes.strings.search_expression),
            enabled = isButtonSearchEnabled,
            borderWidth = 0,
            onClick = onSearchClick,
            onLongClick = onSearchLongClick,
        )

        if (shouldShowAiSearch) {
            AutoResizeItemButtonTextWithLongClick(
                modifier = Modifier
                    .weight(weight)
                    .padding(1.dp),
                text = stringResource(resource = SharedRes.strings.search_ai),
                borderWidth = 0,
                onClick = onAiSearchClick,
            )
        }

        ItemButtonTextWithLongClick(
            modifier = Modifier
                .weight(1.5f)
                .padding(1.dp),
            text = stringResource(resource = SharedRes.strings.left_arrow),
            fontSize = fontSize,
            borderWidth = 0,
            onClick = {
                onHorizontalArrowClick(HorizontalDirection.LEFT)
            },
            onLongClick = {
                onHorizontalArrowLongClick(HorizontalDirection.LEFT)
            },
        )
    }
}

@Preview
@Composable
private fun SearchButtonContentPreview() {
    RightToLeftContainer {
        SearchButtonContent(
            isButtonSearchEnabled = true,
            shouldShowAiSearch = true,
            onSearchClick = {},
            onSearchLongClick = {},
            onAiSearchClick = {},
            onHorizontalArrowClick = {},
            onHorizontalArrowLongClick = {},
        )
    }
}
